/*
File: 直接付费商品账单
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import React from 'react'
import BillWithDate from './BillWithDate'
import { extGoodsPreDayDetail } from '@/api/api'
import * as dateFns from 'date-fns/fp'
import * as R from 'ramda'

const log = R.tap(console.log)

const initStartTime = dateFns.startOfMonth(new Date())
const initEndTime = dateFns.endOfMonth(new Date())

// 20200320 => '2020-03-20'
const formatDate = R.compose(
  R.converge(
    R.unapply(R.join('-')),
    [
      R.slice(0, 4),
      R.slice(4, 6),
      R.slice(6, 8),
    ],
  ),
  R.toString,
)

const columns = [
  {
    title: '日期',
    dataIndex: 'statementDate',
    render: text => <span>{ formatDate(text) }</span>,
  },
  {
    title: '小程序名',
    dataIndex: 'extName',
  },
  {
    title: '商品名',
    dataIndex: 'goodsName',
  },
  {
    title: '有效时长(天)',
    dataIndex: 'expenseLevel',
    render: (text, row) => {
      const days = R.compose(
        R.path(['range', 'max']),
        R.find(R.propEq('id', text)),
        R.propOr([], 'conditions'),
        JSON.parse,
        R.propOr('{}', 'goodsExpenseDetail'),
      )(row)

      return <span>{ days === -1 ? '永久' : days }</span>
    },
  },
  {
    title: '付费金额(虎牙币)',
    dataIndex: 'payExpense',
    render: value => <span>{ parseInt(value, 10) / 100 }</span>,
  },
]

function PreOrderBill() {
  return (
    <BillWithDate
      fetcher={extGoodsPreDayDetail}
      columns={columns}
      initStartTime={initStartTime}
      initEndTime={initEndTime}
      dateFormat="YYYY-MM-DD"
    />
  )
}

export default PreOrderBill
